import { render, staticRenderFns } from "./NotFoundForFamily.vue?vue&type=template&id=50323dd8&"
import script from "./NotFoundForFamily.vue?vue&type=script&lang=js&"
export * from "./NotFoundForFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports